import { render } from "./UpdatePasswordView.vue?vue&type=template&id=1fbc1445&scoped=true"
import script from "./UpdatePasswordView.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordView.vue?vue&type=script&lang=js"

import "./UpdatePasswordView.vue?vue&type=style&index=0&id=1fbc1445&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbc1445"]])

export default __exports__